import script from "./ItemAdder.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemAdder.vue?vue&type=script&setup=true&lang=ts"

import "./ItemAdder.vue?vue&type=style&index=0&id=12fb3a56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12fb3a56"]])

export default __exports__